import { render } from "./Game.vue?vue&type=template&id=74a87ede"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=74a87ede&lang=scss"
script.render = render

export default script